/**
 * Tracking and Analytics Functions
 * --------------------------------
 * @type {Object}
 */
SITE.Tracking = {

    // Record Page Load Time to 
    // calculate time on page
    pageLoadAt: Date.now(),

    init: function() {
        "use strict";
        
        // If the user is logged in, don't do anything
        if ($("body").hasClass("logged-in")) return false;

        SITE.Tracking.GA.init();
        //SITE.Tracking.Conversions.init();

    },

    /**
     * Google Analytics
     * ----------------
     * @type {Object}
     */
    GA: {

        init: function() {
            "use strict";

            // Track Events (Clicks)
            $("a[data-gaevent],button[data-gaevent]").click(function() {

                SITE.Tracking.GA.recordEvent('Button', 'click', $(this).data("gaevent"));

            });

            // Track Events (Form Submissions)
            $("form[data-gaevent]").submit(function() {

                SITE.Tracking.GA.recordEvent('Form', 'submit', $(this).data("gaevent"));

            });

            // Setup Internal Linking
            //SITE.Tracking.GA.InternalLinkage.init();

            /*
            // Scroll Depth
            if($('body').hasClass('single-post')) {
                jQuery.scrollDepth({
                    gtmOverride: true,
                    userTiming: false,
                    pixelDepth: false
                });
            }
            */
        },

        /**
         * Push New Event
         * ---------------
         * 
         * @param {[type]} category [description]
         * @param {[type]} action   [description]
         * @param {[type]} label    [description]
         */
        recordEvent: function(category, action, label) {
            "use strict";

            if (typeof ga !== "undefined") {

                ga('send', {
                          hitType: 'event',
                          eventCategory: category,
                          eventAction: action,
                          eventLabel: label
                        });
            }
        },

    },

    /**
     * Track Conversion Rates
     * 
     * @type {Object}
     */
    Conversions: {

        userID: 0,

        init: function() {
            "use strict";

            SITE.Tracking.Conversions.identify();

            $("form[data-tracking]").submit(function() {
                return SITE.Tracking.Conversions.track($(this).data("tracking"), 'submit');
            });

            $("[data-track-type]").each(function() {
                SITE.Tracking.Conversions.track($(this).data("track-type"), 'show');
            });

            // Mobile Only CTAs
            if (SITE.UI.viewport.mode === "xs") {
                $("[data-track-type-m]").each(function() {
                    SITE.Tracking.Conversions.track($(this).data("track-type-m"), 'show');
                });
            }
        },

        identify: function() {
            "use strict";
            
            var uid = Cookies.get("sg-uid");

            if (typeof uid === "undefined") {
            
                $.get("/conversions-ga/index.php?identify", function(id) {
                    SITE.Tracking.Conversions.userID = id;
                    Cookies.set("sg-uid", id, { expires: 365 });
                });
            
            } else {
                SITE.Tracking.Conversions.userID = uid;
            }

        },

        /**
         * Set User's Email Address
         * -------------------------
         * If user is a subscriber, save the address
         * so that we know who the user is
         * 
         * @param {[type]} email Email Address
         */
        setEmail: function(email) {
            "use strict";

            var data = {
                    email: email,
                    uid: SITE.Tracking.Conversions.userID
                };
            
            $.get("/conversions-ga/index.php", data);

        },


        setDripID: function(dripID) {
            "use strict";

            var data = {
                    dripid: dripID,
                    uid: SITE.Tracking.Conversions.userID
                };
            
            if (SITE.Tracking.Conversions.userID !== 0) {
                $.get("/conversions-ga/index.php", data);
            }

        },

        trackShow: function() {
            "use strict";

            $("[data-track-show]").each(function() {
                SITE.Tracking.Conversions.track($(this).data("track-show"), 'show');
            });
        },

        track: function(type, action) {
            "use strict";

            var data = {
                    type: type, 
                    action: action, 
                    page: window.location.pathname,
                    uid: SITE.Tracking.Conversions.userID
                };
            
            if (data.uid === 0) {
                
                window.setTimeout(function() {
                    SITE.Tracking.Conversions.track(type, action);
                }, 200);

            } else {
                $.get("/conversions-ga/index.php", data, function() {
                    return true;
                });
            }

            return true;

        }

    }
    
};
